var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19141 3.11328L10.0586 2.24609C10.4258 1.87891 11.0195 1.87891 11.3828 2.24609L18.9766 9.83594C19.3437 10.2031 19.3437 10.7969 18.9766 11.1602L11.3828 18.7539C11.0156 19.1211 10.4219 19.1211 10.0586 18.7539L9.19141 17.8867C8.82031 17.5156 8.82812 16.9102 9.20703 16.5469L13.9141 12.0625H2.6875C2.16797 12.0625 1.75 11.6445 1.75 11.125V9.875C1.75 9.35547 2.16797 8.9375 2.6875 8.9375H13.9141L9.20703 4.45313C8.82422 4.08984 8.81641 3.48438 9.19141 3.11328Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.0c245c59840550f356cc4cd65a2904d7.svg";
export { ForwardRef as ReactComponent };